/* eslint-disable @typescript-eslint/naming-convention */

/**
 * App Container Actions
 */
export enum AppAction {
    INIT_STORE = 'CABLE/APP/INIT_STORE',
    START_LOADING = 'CABLE/APP/START_LOADING',
    STOP_LOADING = 'CABLE/APP/STOP_LOADING',
    DELETE_ADDRESS = 'CABLE/APP/DELETE_ADDRESS',
    SET_ERROR = 'CABLE/APP/SET_ERROR',
    SET_AVAILABLE_TARIFFS = 'CABLE/APP/SET_AVAILABLE_TARIFFS',
    SET_INITIAL_TARIFFS = 'CABLE/APP/SET_INITIAL_TARIFFS',
    SET_SELECTED_TARIFF_ID = 'CABLE/APP/SET_SELECTED_TARIFF_ID',
    SET_TV_PRODUCT_SELECTION = 'CABLE/APP/SET_TV_PRODUCT_SELECTION',
    SET_FRIENDS_AND_FAMILY = 'CABLE/APP/SET_FRIENDS_AND_FAMILY',
    SET_GIGAKOMBI = 'CABLE/APP/SET_GIGAKOMBI',
    SET_YOUNG = 'CABLE/APP/SET_YOUNG',
    SET_AVAILABILITY = 'CABLE/APP/SET_AVAILABILITY',
    SET_CUSTOMER = 'CABLE/APP/SET_CUSTOMER',
    LOAD_TV_FOOTNOTE = 'CABLE/APP/LOAD_TV_FOOTNOTE',
    SET_LOGIN_STATUS = 'CABLE/APP/SET_LOGIN_STATUS',
    SET_BANNER_ID = 'CABLE/APP/SET_BANNER_ID',
    RESET_STATE = 'CABLE/APP/RESET_STATE',
}

/**
 * Error types
 */
export enum ErrorType {
    CMS_CONFIG = 'CMS Config error',
    AVC_ERROR = 'Availability check error',
    JARVIS = 'Jarvis error',
    LM_VALIDATION_ERROR = 'Lead Management Validation error',
    ZP_API = 'ZP-API error',
    NOT_UNIQUE_ADDRESS = 'Address not unique error',
    NOT_FOUND_ADDRESS = 'Address not found error',
}
